import { Company } from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'

export const useUserCompanies = () => {
  const { server } = useServer()

  async function fetchCompaniesForUser() {
    const response = await server.get<Company[]>('/v2/chat/user/companies')
    return response
  }

  return useQuery({
    queryKey: keys.userCompanies,
    queryFn: fetchCompaniesForUser,
  })
}
